import { useAtom, useSetAtom } from "jotai";
import React, { useEffect } from "react";
import styled from "styled-components";
import {
  bookInfoPopState,
  soundPopState,
  wordPopState,
  activityPopState,
  gamePopState,
} from "@stores/popup";
import PopupCloseButton from "@components/elements/PopupCloseButton";
import { useNavigate } from "react-router";

const Wrap = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  z-index: 100;
  animation: scaleIn 0.7s cubic-bezier(0.33, 1, 0.68, 1);
  animation-fill-mode: forwards;
`;

const Background = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  background: url(${({ url }) => url});
  background-size: 150%;
  background-position: center center;
`;
const BgCover = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(18, 37, 70, 0.9);
`;

const BookCover = styled.div`
  width: 600px;
  height: 600px;
  border-radius: 40px;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background: url(${({ url }) => url}) no-repeat;
  background-size: cover;
  background-position: 50% 50%;
`;

const ObjectWrap = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  .column {
    opacity: 0;
    animation: slideDown 0.6s cubic-bezier(0.34, 1.56, 0.64, 1);
    animation-fill-mode: forwards;
    animation-delay: 0.1s;
    flex: 0 auto;
    &:first-child {
      margin-right: 40px;
    }
  }
`;

const Grade = styled.span`
  font-size: 40px;
  color: #ffba00;
  display: block;
`;
const Title = styled.span`
  font-size: 60px;
  color: #fff;
  display: block;
  margin-top: 10px;
`;

const StartButton = styled.button`
  display: inline-block;
  width: 568px;
  height: 137px;
  margin-top: 35px;
  background: url(${require("@assets/img/start_button.png")});
`;
const IconButtonWrap = styled.div`
  width: 570px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
`;

const IconButton = styled.button`
  display: inline-block;
  width: 276px;
  height: 130px;
  margin-top: 14px;
  &.disabled {
    //filter: grayscale(1);
    // visibility: hidden;
    display: none;
    pointer-events: none;
  }
  &.ty1 {
    background: url(${require("@assets/img/icon_button_song.png")});
  }
  &.ty2 {
    background: url(${require("@assets/img/icon_button_word.png")});
  }
  &.ty3 {
    background: url(${require("@assets/img/icon_button_activity.png")});
  }
  &.ty4 {
    background: url(${require("@assets/img/icon_button_game.png")});
  }
`;

const BookInfo = () => {
  const [bookInfo, setBookInfo] = useAtom(bookInfoPopState);
  const setSoundAndReadData = useSetAtom(soundPopState);
  const setActivity = useSetAtom(activityPopState);
  const setGame = useSetAtom(gamePopState);
  const setWord = useSetAtom(wordPopState);

  const navigate = useNavigate();

  const onClose = () => {
    setBookInfo({
      open: false,
    });
  };

  // 사운드 플레이 팝업 오픈
  const onOpenSound = () => {
    // onClose();

    setSoundAndReadData({
      open: true,
      cover: bookInfo.cover,
      category: bookInfo.category,
      title: bookInfo.title,
      grade: bookInfo.grade,
      url: bookInfo.song.url,
      songTitle: bookInfo.song.title,
      caption: bookInfo.song.caption,
    });
  };

  // 낱말 오픈
  const onOpenWord = () => {
    // onClose();
    if (bookInfo.word.length === 0) {
      setWord({
        open: true,
        mode: "word2",
        data: bookInfo.word || [],
        data2: bookInfo.idiom || [],
      });
    } else {
      setWord({
        open: true,
        mode: "word",
        data: bookInfo.word || [],
        data2: bookInfo.idiom || [],
      });
    }
  };

  //엑티비티 오픈
  const onOpenActivity = () => {
    // onClose();
    setActivity({
      open: true,
      type: bookInfo.activity.type,
      questions: bookInfo.activity.questions,
    });
  };

  const onOpenGame = () => {
    // onClose();
    setGame({
      open: true,
      data: bookInfo.game,
      categoryKey: bookInfo.categoryKey,
    });
  };

  // 책 시작
  const onStartBook = () => {
    onClose();
    navigate(`${bookInfo.categoryKey}/${bookInfo.key}`);
  };

  return bookInfo.open === true ? (
    <Wrap id="popupBookInfo">
      <Background url={bookInfo.background} />
      <BgCover />
      <ObjectWrap>
        <div className="column">
          <BookCover url={bookInfo.cover} />
        </div>
        <div className="column">
          <Grade>{`${bookInfo.category} ${bookInfo.grade}`}</Grade>
          <Title>{bookInfo.title}</Title>
          <StartButton type="button" onClick={onStartBook} />
          <IconButtonWrap>
            <IconButton
              type="button"
              className={
                bookInfo.song && bookInfo.song.url !== ""
                  ? "ty1"
                  : "ty1 disabled"
              }
              onClick={onOpenSound}
            />
            <IconButton
              type="button"
              className={
                bookInfo.word.length > 0 || bookInfo.idiom.length > 0
                  ? "ty2"
                  : "ty2 disabled"
              }
              onClick={onOpenWord}
            />

            <IconButton
              type="button"
              className={
                bookInfo.activity.questions.length > 0 ? "ty3" : "ty3 disabled"
              }
              onClick={onOpenActivity}
            />
            <IconButton
              className={
                bookInfo.game && bookInfo.game.resources.length > 0
                  ? "ty4"
                  : "ty4 disabled"
              }
              onClick={onOpenGame}
            />
          </IconButtonWrap>
        </div>
      </ObjectWrap>
      <PopupCloseButton onClick={onClose} />
    </Wrap>
  ) : null;
};

export default BookInfo;
